module.exports = __webpack_public_path__ + "img/9order.d98b5ba1.png";